module.exports = ".textField {\n  width: 50%; }\n\n.fixPos {\n  left: 10em; }\n\n.space {\n  margin-right: 2em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/userform.component.scss
// module id = 594
// module chunks = 1